class ProductFloatingVideo extends HTMLElement {
  connectedCallback() {
    this.closeButton = this.querySelector('.product-floating-video__close');
    this.frame = this.querySelector('[data-floating-video-frame]');
    this.videoUrl = this.dataset.videoUrl;

    const videoId = this.getYouTubeId(this.videoUrl);
    if (!videoId || !this.frame) {
      this.hidden = true;
      return;
    }

    this.renderIframe(videoId);
    this.closeButton?.addEventListener('click', this.close.bind(this));
  }

  getYouTubeId(url) {
    try {
      const parsedUrl = new URL(url);
      const hostname = parsedUrl.hostname.replace(/^www\./, '');

      if (hostname === 'youtu.be') {
        return parsedUrl.pathname.split('/').filter(Boolean)[0];
      }

      if (!hostname.includes('youtube.com')) return null;

      if (parsedUrl.searchParams.get('v')) {
        return parsedUrl.searchParams.get('v');
      }

      const parts = parsedUrl.pathname.split('/').filter(Boolean);
      const supportedPaths = ['embed', 'shorts', 'live'];
      if (supportedPaths.includes(parts[0])) {
        return parts[1];
      }
    } catch (error) {
      return null;
    }

    return null;
  }

  renderIframe(videoId) {
    const iframe = document.createElement('iframe');
    const params = new URLSearchParams({
      autoplay: '1',
      mute: '1',
      playsinline: '1',
      controls: '1',
      rel: '0',
      modestbranding: '1',
      enablejsapi: '1',
      origin: window.location.origin,
    });

    iframe.src = `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
    iframe.title = 'Product video';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;

    this.frame.replaceChildren(iframe);
  }

  close() {
    this.hidden = true;
  }
}

if (!customElements.get('product-floating-video')) {
  customElements.define('product-floating-video', ProductFloatingVideo);
}
